// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"5b0778d8a558362f","922":"856ff884c7a9af2b"}[chunkId] + ".css";
};